import {LoginUIManager} from "@/Core/Login/LoginUIManager";
import CallTempData from "@/Core/Bridge/CallTempData";

type GameInitData={
    hot_fix_url: string,
    game_id: number,
    res_ver: string,
}

type GameLoginData={
    login_id:string;
    login_token:string;
    ext_info:string;
}

export class GameInitConfig {
    game_init_data!:GameInitData;
    version_data!:string;
    login_data!: GameLoginData;
    constructor() {
        this.game_init_data = {
            hot_fix_url: "https://oss-gz-sc-zydown.oss-accelerate.aliyuncs.com/SlotGameCenterH5/slot_assets/version_1",
            game_id: CallTempData.getGameId,
            res_ver: "1.0.0",
        };
        this.version_data = "{\n    \"2e5921ca39e3042ea5ef81320e1f4500\":\"baaadc5429072c841dfc3d4647d9964f\",\n    \"2fc4d08a64ce815370cbd531a9a616dd\":\"2d62f670fc86e0a5c434fc3b193159dc\",\n    \"3c5ef246c55f0eb59663697d80ba1662\":\"8eb70b8d8aba20a8280b9975e12c63a7\",\n    \"4e1c0f7d783431a480eb07da1d4d1135\":\"3becc7711e2cd19ba18b83575ed2e693\",\n    \"6837e60d5729ac6789863cd921bbe8b9\":\"0fb2ce9961afd54dbb770e6dd8b003d9\",\n    \"73edee88e98539f5a438dd493df14588\":\"d3ca48c2609952edbe28f77b9e475a55\",\n    \"75a930bb7d0b117e89b111d2b0478137\":\"9fd0bb95a7518a421099dfe3e3f30db7\",\n    \"832b871e2795b53e8b70dec4fd951233\":\"1585fe3c6fd140e3eab7ce6160b0337b\",\n    \"888cf4e4d92ac52d58acf9e971e77661\":\"69c2a48564d3a9052f9db23bedd5320b\",\n    \"ad045351f67e8035bff6f1d7bf14e5a7\":\"9125e8bbc0024c9c6f318655b20df017\",\n    \"ad390073daca4c94cd29295847de4316\":\"1b8b420333a21fa9ca8898a885d89142\",\n    \"b25a3fdf727964042aabf687d2bbfd2b\":\"c28715b4e010ded148058107717a3c77\",\n    \"b9dd1b5bb857a99f7191687b28e3b880\":\"16ffa1340817424480c98cfa0d27aa8a\",\n    \"ba46b4ca090ecc6854384705c7eb035d\":\"3a3aeb09b5d5b78aac60f90a2803b6f6\",\n    \"ba47e124bb4a45c17ffb1f7e5ca8123c\":\"cd67d7fe1048813414d7b4d2c1c4150d\",\n    \"bd0a58489c98cdf7eec67a16e984bdaf\":\"159df7409e4b9a13c3bbf9070f2139f1\",\n    \"e01d26d3be4924d9c86485536ae85344\":\"bc95066ddb7e4132142133578e8832c1\",\n    \"f1565e3820e9a636d01ee941162b95fe\":\"33c8f31db4741b3142f66c32c4675cb1\"\n}";
        this.login_data = {
            login_id: LoginUIManager.getLastUserId+'',
            login_token: LoginUIManager.getLastUserToken,
            ext_info: "null",
        };
    }

    public toString(){
        return JSON.stringify(this);
    }

}
